var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"covid-alert"},[_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_c('strong',[_vm._v("Know before you go.")]),_vm._v(" The restrictions surrounding COVID-19 change often. Please stay informed before traveling. Stay safe. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }